/* eslint-disable camelcase */
import { getBrowser } from '@/utils'
import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, ActionTree } from 'vuex'
import store from '.'
Vue.use(Vuex)

export interface WebviewConfigState {
  ver_no: string;
  device: string;
  os_ver: string;
  bank_name: string;
  upload_image_server: string | null;
  cal1_cost: string;
}

const getDefaultState = (): WebviewConfigState => {
  return {
    ver_no: process.env.VUE_APP_VERSION,
    device: getBrowser(),
    os_ver: window.navigator.platform,
    bank_name: localStorage.getItem('FBAdString') || '',
    upload_image_server: null,
    cal1_cost: ''
  }
}
const state = getDefaultState()

const getters: GetterTree<WebviewConfigState, any> = {
  platform (state: WebviewConfigState) {
    if (store.getters.isWebViewMode) {
      if (/DROID/g.test(state.ver_no)) {
        return 'ANDR'
      } else {
        return 'IOS'
      }
    } else {
      return 'WEB'
    }
  },
  ver_no (state: WebviewConfigState) {
    return state.ver_no
  },
  device (state: WebviewConfigState) {
    return state.device
  },
  os_ver (state: WebviewConfigState) {
    return state.os_ver
  },
  bank_name (state: WebviewConfigState) {
    return state.bank_name
  },
  upload_image_server (state: WebviewConfigState) {
    return state.upload_image_server
  },
  cal1_cost (state: WebviewConfigState) {
    return state.cal1_cost
  }
}

const mutations: MutationTree<WebviewConfigState> = {
  SET_WEBVIEW (state: WebviewConfigState, payload: WebviewConfigState) {
    // https://stackoverflow.com/questions/61596158/vuex-mutation-best-practices-merging-state-with-payload
    state.ver_no = payload.ver_no || state.ver_no
    state.device = payload.device || state.device
    state.os_ver = payload.os_ver || state.os_ver
    state.bank_name = payload.bank_name || state.bank_name
    state.upload_image_server = payload.upload_image_server || state.upload_image_server
    state.cal1_cost = payload.cal1_cost || state.cal1_cost
  },
  SET_DEFAULT (state: WebviewConfigState) {
    state = getDefaultState()
  }
}

const actions: ActionTree<WebviewConfigState, any> = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
